import { useEffect, useState } from "react";
import { elapsedMs, formatDurationMs } from "../lib/time.js";

export function Elapsed({ startedAt }: { startedAt: string }) {
  const [, force] = useState(0);
  useEffect(() => {
    const t = window.setInterval(() => force((n) => n + 1), 1000);
    return () => window.clearInterval(t);
  }, []);
  return <>{formatDurationMs(elapsedMs(startedAt))}</>;
}
